import Vue from 'vue'

export async function getProveedores(context, [access_token, showload]) {
    try {
       
        if (showload){
          context.commit('setLoading', true, { root: true })
        }
        const response = await Vue.axios({
            method: 'GET',
            url: '/proveedores',
            headers: {
                //  'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            

        })
        context.commit('prov/setProveedores', response.data.data, { root: true })
    } catch (e) {
    } finally {
        if (showload){
            context.commit('setLoading', false, { root: true })
        }
    }
}



export async function updateProveedor(context, [access_token, prov]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'PATCH',
            url: '/proveedores/' + prov.id,
            headers: {
                //'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                proveedor: prov,
               
            }
        })
        if (response.status == 200) {
            context.commit('prov/actListProveedores', response.data, { root: true })
            return response.data
        }
    } catch (e) {
      
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}




export async function createProveedor(context, [access_token, prov]) {
    try {
        
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/proveedores',
            headers: {
                //'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
               
                proveedor: prov,
               
                
            }
        })
        if (response.status == 200) {
          //  context.commit('prov/actListProveedores', response.data, { root: true })
            return response.data
        }
       
    } catch (e) {
      
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}



export async function deleteProveedor(context, [access_token, id]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/proveedordelete',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                id: id,
            }
        })
       
        if (response.status == 201) {
            context.commit('prov/actDeleteListProveedores', id, { root: true })
        }
       
    } catch (e) {
       
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}












